export enum InventorySanitisationMethod {
  CLEAR = "CLEAR",
  DESTROY = "DESTROY",
  PURGE = "PURGE",
}
